import { useState } from "react";
import { ArrowRight, Loader2 } from "lucide-react";
import { useLang } from "@/lib/i18n";
import { validate, submitEnquiry, errMsg } from "@/lib/enquiry";
import { Field, inputCls, Success } from "@/components/forms/FormBits";

const EMPTY = { company: "", contact_name: "", email: "", phone: "", message: "" };

export const ShortEnquiryForm = ({ kind = "short", dark = false, testId = "short-form" }) => {
  const { t, lang } = useLang();
  const q = t.quote;
  const [v, setV] = useState(EMPTY);
  const [errors, setErrors] = useState({});
  const [state, setState] = useState({ status: "idle", id: "", error: "" });
  const set = (k) => (e) => setV((p) => ({ ...p, [k]: e.target.value }));

  const onSubmit = async (e) => {
    e.preventDefault();
    const errs = validate(v, t);
    setErrors(errs);
    if (Object.keys(errs).length) return;
    setState({ status: "sending", id: "", error: "" });
    try {
      const id = await submitEnquiry(kind, lang, v);
      setState({ status: "done", id, error: "" });
      setV(EMPTY);
    } catch (err) {
      setState({ status: "idle", id: "", error: errMsg(err, q.error) });
    }
  };

  if (state.status === "done") {
    return <Success dark={dark} testId={`${testId}-success`} title={q.successTitle} body={q.successBody} refLabel={q.ref} refId={state.id} again={q.another} onAgain={() => setState({ status: "idle", id: "", error: "" })} />;
  }
  const f = (k, label, type = "text", req = false, extra = {}) => (
    <Field id={`${testId}-${k}`} label={label} error={errors[k]} required={req}>
      <input id={`${testId}-${k}`} data-testid={`${testId}-${k}`} type={type} value={v[k]} onChange={set(k)} className={inputCls(errors[k], dark)} {...extra} />
    </Field>
  );
  return (
    <form onSubmit={onSubmit} noValidate data-testid={testId} className="grid gap-8 sm:grid-cols-2">
      {f("company", q.f.company, "text", true, { autoComplete: "organization" })}
      {f("contact_name", q.f.contact, "text", true, { autoComplete: "name" })}
      {f("email", q.f.email, "email", true, { autoComplete: "email", dir: "ltr" })}
      {f("phone", q.f.phone, "tel", false, { autoComplete: "tel", dir: "ltr" })}
      <Field id={`${testId}-message`} label={q.f.message} className="sm:col-span-2">
        <textarea id={`${testId}-message`} data-testid={`${testId}-message`} rows={3} value={v.message} onChange={set("message")} className={`${inputCls(false, dark)} resize-none`} />
      </Field>
      <div className="flex flex-col gap-4 sm:col-span-2 sm:flex-row sm:items-center sm:justify-between">
        <button type="submit" disabled={state.status === "sending"} data-testid={`${testId}-submit`} className="btn-brass justify-center disabled:opacity-60">
          {state.status === "sending" ? <><Loader2 className="h-4 w-4 animate-spin" />{q.f.sending}</> : <>{q.f.submit}<ArrowRight className="h-4 w-4 rtl:-scale-x-100" /></>}
        </button>
        {state.error && <p className="text-sm text-[#F97066]" role="alert" data-testid={`${testId}-error`}>{state.error}</p>}
      </div>
    </form>
  );
};
